import './HoneycombChart.css';
export var graphContainer = '_1vkdryk0-2-0-1';